import { useState } from "react";
import { authService } from "../services/authService";

export const useSignUp = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    agreement: false,
  });

  const [status, setStatus] = useState({
    loading: false,
    success: false,
    message: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    if (status.message) setStatus((prev) => ({ ...prev, message: "" }));
  };

  const validate = () => {
    const { email, password, agreement, firstName, lastName } = formData;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!firstName.trim()) return "Please enter your name.";
    if (!lastName.trim()) return "Please enter last name.";
    if (!emailPattern.test(email)) return "Please enter a valid email address.";
    if (password.length < 8) return "Password must be at least 8 characters.";
    if (!agreement) return "Please accept the terms to continue.";
    return null;
  };

  const handleSubmit = async () => {
    const error = validate();
    if (error)
      return setStatus({ loading: false, success: false, message: error });

    setStatus({ loading: true, success: false, message: "" });

    try {
      const res = await authService.signUp(formData);
      const { success, message } = res;
      setStatus({ loading: false, success, message });
    } catch (err) {
      const errMsg =
        err.response?.data?.message || "Registration failed. Try again.";
      setStatus({ loading: false, success: false, message: errMsg });
    }
  };

  return { formData, status, handleChange, handleSubmit };
};
